import React from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalNavigation from "Common/GlobalNavigationObj";
import { activeMainTab } from "Redux/TabsSlice/TabsSlice";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import NoAccessScreen from "Components/NoAccessScreen/NoAccessScreen";

const RightsWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const rawUserModuleRights =
    useSelector((state) => state.userAuth.userinfo.userModuleRights);
  const currentActiveTab = useSelector((state) => state.tabs.mainTab)?.name;

  const allTabs = GlobalNavigation;
  const userModuleRights =
    rawUserModuleRights === null || rawUserModuleRights === undefined
      ? allTabs.reduce((acc, tab) => {
        acc[tab.navigationName] = true;
        return acc;
      }, {})
      : rawUserModuleRights ?? {};

  const hasAnyAccess = Object.keys(userModuleRights).length > 0 &&
    allTabs.some((tab) => userModuleRights[tab.navigationName]);

  if (Object.keys(userModuleRights).length === 0 || !hasAnyAccess) {
    return <NoAccessScreen />;
  }

  const currentTab = currentActiveTab
    ? allTabs.find(
      (tab) =>
        tab.navigationName === currentActiveTab ||
        tab.name === currentActiveTab
    )?.navigationName
    : "";
  const hasRight = userModuleRights[currentTab];
  let navigationTab;
  if (!hasRight && currentTab) {
    navigationTab = allTabs.find((tab) => userModuleRights[tab.navigationName]);
    if (navigationTab)
      navigationTab = {
        name: navigationTab.navigationName,
        key: navigationTab.key,
        activeTab: navigationTab.navigationName,
        right: navigationTab.right,
        title: navigationTab.title,
        data: null,
      };
  }
  if (!navigationTab && !hasRight) {
    return <FullPageLoader />;
  } else if (navigationTab && !hasRight && navigationTab.name !== currentActiveTab) {
    dispatch(activeMainTab(navigationTab));
    return;
  } else {
    return children;
  }
};

export default RightsWrapper;
